import { showModal } from './showModal'

export const checkError = (array, key) => array[key] && showModal(key)
